<template>
  <input class="n-input" type="text" :placeholder="placeholder">
</template>

<script>
export default {
  name: 'bInput',
  props: {
    /**
     * input的提示信息
     * @param placeholder
     */
    placeholder: {
      type: [String, Number],
      default: () => ''
    }
  }
}
</script>
